"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@mui/material/styles");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
// @inheritedComponent IconButton

var useStyles = exports.useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    label: {},
    rootCustomColor: function rootCustomColor(props) {
      var color;
      if (theme.palette[props.color]) {
        color = theme.palette[props.color].main;
      } else if (props.color.charAt(0) === '#') {
        color = props.color;
      }
      if (!color) return {};
      return {
        color: color,
        '&:hover': {
          backgroundColor: (0, _styles.alpha)(color, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      };
    }
  };
});
var HiIconButton = _react.default.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    color = props.color,
    other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "color"]);
  var classes = useStyles(props);
  var isHexColor = color.charAt(0) === '#';
  var isExtendedColor = ['success', 'error', 'warning', 'neutral'].includes(color);
  var isCustomColor = isHexColor || isExtendedColor;
  var rootClassNames = (0, _classnames.default)((0, _defineProperty2.default)({}, classes.rootCustomColor, isCustomColor));
  return /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    className: className,
    classes: {
      root: rootClassNames,
      label: classes.label
    },
    color: isCustomColor ? 'inherit' : color,
    size: "large"
  }, other), children);
});
HiIconButton.defaultProps = {
  color: 'neutral'
};
var _default = exports.default = HiIconButton;